import React from "react";

import "./membershipCard.css";

export default function MembershipCard({
  data,
  isActive,
  isChecked,
  onSelect,
  onTermClick
}) {
  return (
    <div className={`membershipCard radius20 ${isActive ? "active" : ""}`}  onClick={() =>{onSelect()}}>
      <div className="membershipCard__Header">
        <div className="form-check">
          <label className="form-check-label">{data.name}</label>
          <input
            className="form-check-input"
            type="radio"
            name="membership"
            checked={isChecked}
            onChange={onSelect} // Ensure the onChange is tied to onSelect
          />
        </div>
      </div>
      <div className="membershipCard__Body">
        <div className="d-flex justify-content-between">
          <div>Joining</div>
          <span>₹ {data.joining}</span>
        </div>
        <div className="d-flex justify-content-between">
          <div>Annual Fees</div>
          <span>₹ {data.annual_fee}</span>
        </div>
        <p className="membershipCard__Note">*Prices are excluding GST</p>
      </div>
      <div className="membershipCard__Footer">
        <button type="button" onClick={()=>{onTermClick()}}>
          Eligibility
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path d="M0,0H24V24H0Z" fill="none" />
              <path
                d="M9,6l6,6L9,18"
                fill="none"
                stroke="#333"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
              />
            </svg>
          </span>
        </button>
      </div>
    </div>
  );
}
